
<template>
  <Teleport to="body">
    <Transition name="fade-tooltip">
      <div
        v-if="visible"
        class="custom-tooltip"
        :style="{
          top: `${position.top}px`,
          left: `${position.left}px`,
        }"
      >
        {{ text }}
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    required: true,
  },
  visible: {
    type: Boolean,
    required: true,
  },
  position: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped lang="scss">
.custom-tooltip {
  position: fixed;
  transform: translate(-50%, -100%);
  background-color: #4b5563;
  color: #ffffff;
  padding: 0.5rem;
  border-radius: 6px;
  font-size: 0.875rem;
  max-width: 215px;
  white-space: normal;
  word-wrap: break-word;
  z-index: 9999;
  pointer-events: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.custom-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #4b5563;
}

.fade-tooltip-enter-active,
.fade-tooltip-leave-active {
  transition: opacity 0.15s ease;
}

.fade-tooltip-enter-from,
.fade-tooltip-leave-to {
  opacity: 0;
}
</style>
